import {StormpathConfiguration} from 'angular-stormpath';

/**
 * Created by Rodrigo Quesada on 18/11/16.
 */
export const STORMPATH_CONFIG = new StormpathConfiguration();
STORMPATH_CONFIG.endpointPrefix = process.env.BACKEND_BASE_URI;
STORMPATH_CONFIG.autoAuthorizedUris.push(new RegExp(`${process.env.BACKEND_BASE_URI}/api/*`));
STORMPATH_CONFIG.autoAuthorizedUris.push(new RegExp(`${process.env.OCR_SERVICE_BASE_URI}/api/*`));



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/@angularclass/hmr-loader!./~/tslint-loader!./src/app/infrastructure/security/stormpath/stormpath.config.ts